export default {
    zoho_estimate_id: "Número de estimación de Zoho",
    zoho_estimate_number_short: "Estimación de Zoho #",
    zoho_total: "Total de Zoho",
    zoho_status: "Estado de Zoho",
};
